import React from 'react';
import {connect} from 'react-redux';

import {getValue, TESTS} from '../../../utils/abacus';
import BreadCrumbs from '../../../modules/BreadCrumbs';
import SEOIntroductionParagraphModule from '../../../modules/seo-introduction-paragraph/SEOIntroductionParagraphModule';
import {withErrorBoundary} from '../../../templates/helpers';
import AsyncGlobalAlertContainer from '../global-messaging-alert/AsyncGlobalAlertContainer';

export function AboveFold(props) {
    const {
        showBreadcrumbs,
        allowDynamicSeoIntroParagraph,
        useGlobalMessageServiceForAlertInfoBox,
    } = props;

    const alertInfoBox = useGlobalMessageServiceForAlertInfoBox
        ? withErrorBoundary(<AsyncGlobalAlertContainer />)
        : null;

    return (
        <>
            {alertInfoBox}
            <div className="top-group-container">
                {showBreadcrumbs && withErrorBoundary(<BreadCrumbs />)}
                {allowDynamicSeoIntroParagraph &&
                    withErrorBoundary(<SEOIntroductionParagraphModule />)}
            </div>
        </>
    );
}

export function mapStateToProps({options = {}, abacus}) {
    return {
        showBreadcrumbs: options.allowBreadcrumbs,
        allowDynamicSeoIntroParagraph: options.allowDynamicSeoIntroParagraph,
        useGlobalMessageServiceForAlertInfoBox:
            getValue(abacus, TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT) === 1,
    };
}

export default connect(mapStateToProps)(AboveFold);
